import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';


export const defaultState = fromJS({
    isLoading: false,
    isConnecting: false,
    isExporting: false,
    session: null,
    report: null,
});

export default handleActions({
    REPORTS: {
        LOADING: {
            ON: state => state.set('isLoading', true),
            OFF: state => state.set('isLoading', false),
        },

        CONNECTING: {
            ON: state => state.set('isConnecting', true),
            OFF: state => state.set('isConnecting', false),
        },

        EXPORTING: {
            ON: state => state.set('isExporting', true),
            OFF: state => state.set('isExporting', false),
        },

        SESSION: {
            /*
                NOTE: this is not stored as immutable
                and will not be visible in devTool but still works
            */
            SET: (state, { payload }) => state.set('session', payload),
            CLEAR: state => state.set('session', null),
        },
        REPORT: {
            /*
                NOTE: this is not stored as immutable
                and will not be visible in devTool but still works
            */
            SET: (state, { payload }) => state.set('report', payload),
            CLEAR: state => state.set('report', null),
        },
    },
}, defaultState);
